module.exports = __webpack_public_path__ + "media/Stream of Life.c81d3efb.mp3";